import VideoManagement from './VideoManagement';
import VideoBrowse from './VideoBrowse';
import VideoEditor from './VideoEditor';

export { VideoBrowse, VideoEditor };
export default VideoManagement;
